<clr-datagrid class="datagrid-compact" [(clrDgSelected)]="selectedFiltered" [clrDgRowSelection]="true">

  <!-- <clr-dg-action-bar>
    <button type="button" class="btn btn-sm btn-secondary" (click)="removeSelected()">
      <clr-icon shape="remove"></clr-icon> Премахни
    </button>
</clr-dg-action-bar> -->

  <clr-dg-column [clrDgField]="'Name'">Наименование</clr-dg-column>
  <clr-dg-column [clrDgField]="'Store.Name.BG'">Склад</clr-dg-column>
  <clr-dg-column [clrDgField]="'Note'">Забележка</clr-dg-column>
  <clr-dg-column [clrDgField]="'StandardCostPerLot'">Стандартна себестойност</clr-dg-column>
  <clr-dg-column [clrDgField]="'ReleaseDate'">ReleaseDate</clr-dg-column>
  <clr-dg-column [clrDgField]="'ExpiryDate'">ExpiryDate</clr-dg-column>

  <clr-dg-row *clrDgItems="let recipie of recipes" [clrDgItem]="recipie">
    <clr-dg-cell>{{recipie.Name}}</clr-dg-cell>
    <clr-dg-cell>{{recipie.Store?.Name?.BG}}</clr-dg-cell>
    <clr-dg-cell>{{recipie.Note}}</clr-dg-cell>
    <clr-dg-cell>{{recipie.Product?.StandardCostPerLot?.Value}} {{recipie.Product?.StandardCostPerLot?.Currency}}</clr-dg-cell>
    <clr-dg-cell>{{recipie.ReleaseDate | date}}</clr-dg-cell>
    <clr-dg-cell>{{recipie.ExpiryDate | date}}</clr-dg-cell>

    <ng-container ngProjectAs="clr-dg-row-detail">
      <clr-dg-row-detail *clrIfExpanded>
        <clr-datagrid style="width: 50%;">
          <clr-dg-column [clrDgSortBy]="'LineOrd'">Ред</clr-dg-column>
          <clr-dg-column>Материал</clr-dg-column>
          <clr-dg-column>Количество</clr-dg-column>
          <clr-dg-column>Стандартна себестойност</clr-dg-column>

          <clr-dg-row *ngFor="let ingredient of recipie.Ingredients">
              <clr-dg-cell>{{ingredient.LineOrd}}</clr-dg-cell>
              <clr-dg-cell>{{ingredient.Material?.Name?.BG}}</clr-dg-cell>
              <clr-dg-cell>{{ingredient.UsageQuantity?.Value}} {{ingredient.UsageQuantity?.Unit}}</clr-dg-cell>
              <clr-dg-cell>{{ingredient.Material?.StandardCostPerLot?.Value}} {{ingredient.Material?.StandardCostPerLot?.Currency}}</clr-dg-cell>
          </clr-dg-row>
      
          <clr-dg-footer>{{recipie.Ingredients.length}} съставки</clr-dg-footer>
      </clr-datagrid>
    </clr-dg-row-detail>
    </ng-container>


  </clr-dg-row>

  <!-- <clr-dg-detail *clrIfDetail="let recipie">
    <clr-dg-detail-header>{{recipie.Name}}</clr-dg-detail-header>
    <clr-dg-detail-body>
      
    </clr-dg-detail-body>
  </clr-dg-detail> -->

  <clr-dg-footer>
    <clr-dg-pagination #pagination [clrDgPageSize]="10">
        <clr-dg-page-size [clrPageSizeOptions]="[10,20,50,100]">Технологии на страница</clr-dg-page-size>
        {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
        от {{pagination.totalItems}} технологии
    </clr-dg-pagination>
  </clr-dg-footer>
</clr-datagrid>